// services/dashboard/consolidateFactorsData.js

/**
 * 🔄 Consolida datasets sumando todos los valores
 * @param {Object} data - Objeto con etiquetas y datasets de factores
 * @returns {Object} Datos consolidados con totales por etiqueta
 */
export const consolidateFactorsData = (data) => {
    if (!data || !data.datasets || data.datasets.length === 0) {
        return data;
    }

    // Mapa para agrupar por etiqueta (label)
    const consolidatedMap = {};

    data.datasets.forEach(dataset => {
        const key = dataset.label;

        // 🚨 VALIDACIÓN: Excluir datasets sin label válido (factores filtrados previamente)
        if (!key || key === 'Factor sin nombre') {
            console.log(`⛔ Ignorando dataset sin label válido durante consolidación`);
            return; // Continuar con el siguiente dataset
        }

        if (!consolidatedMap[key]) {
            // Inicializar la entrada en el mapa si es la primera vez que se ve la etiqueta
            consolidatedMap[key] = {
                label: dataset.label,
                data: [...dataset.data],
                backgroundColor: Array.isArray(dataset.backgroundColor)
                    ? dataset.backgroundColor[0]
                    : dataset.backgroundColor,
                borderColor: Array.isArray(dataset.borderColor)
                    ? dataset.borderColor[0]
                    : dataset.borderColor,
                borderWidth: dataset.borderWidth,
                unit: dataset.unit
            };
        } else {
            // Si ya existe la etiqueta, sumar los valores del arreglo 'data'
            dataset.data.forEach((value, index) => {
                if (consolidatedMap[key].data[index] !== undefined) {
                    consolidatedMap[key].data[index] += value;
                } else {
                    consolidatedMap[key].data[index] = value;
                }
            });
        }
    });

    // Mapear el objeto consolidado a la estructura final
    const consolidatedDatasets = Object.values(consolidatedMap).map(dataset => {
        // Reducir todo el arreglo data a un único valor total
        const total = dataset.data.reduce((sum, val) => sum + val, 0);
        return {
            ...dataset,
            data: [Number(total.toFixed(2))],
        };
    });

    console.log('🔄 Factors consolidados:', {
        originalDatasets: data.datasets.length,
        consolidatedDatasets: consolidatedDatasets.length
    });

    return {
        labels: ['Consolidado'],
        datasets: consolidatedDatasets
    };
};